import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import storePersist from '../../../../../../redux/storePersist';
import { deepCopy } from '../../../../../../common/services/common.service';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { shippingProviders } from '../../../../../../redux/shipping-providers/action';
import { selectShippingProvidersListItems } from '../../../../../../redux/shipping-providers/selector';
import { orgRegistries } from '../../../../../../redux/org-registries/action';
import { selectOrgRegistriesListItems, selectOrgRegistriesQueryItems } from '../../../../../../redux/org-registries/selector';
import UploadFiles from '../../../../../../models/UploadFile';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { settings } from '../../../../../../redux/settings/actions';
import { selectDbnpRegistriesListItems } from '../../../../../../redux/dbnp-registries/selector';
import { dbnpRegistries } from '../../../../../../redux/dbnp-registries/action';
import OrgRegistryComponent from '../components/org-registry/components/org-registry.component';
import { selectShippingTypesListItems } from '../../../../../../redux/shippingTypes/selector';
import { shippingTypes } from '../../../../../../redux/shippingTypes/action';

let currentChange: any = {}
const DBNPOrgRegistry = () => {
  const { dbnpRegistryId,id} = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const orgRegistryQuery = useSelector(selectOrgRegistriesQueryItems)
  const orgRegistryListItems = useSelector(selectOrgRegistriesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const accountsItems = useSelector(selectAccountsListItems)
  const shippingProvidersListItems = useSelector(selectShippingProvidersListItems)
  const shippingTypesListItems = useSelector(selectShippingTypesListItems)
  const libraryListItems = storePersist?.get("library")?.current;
  const [orgRegistry, setOrgRegistry] = useState<any>([])
  const [selectedOrgRegistry, setSelectedOrgRegistry] = useState<any>({
    Circle: {
      radius: {}
    },
    Time: {
      schedule: {},
      range: {}
    }
  })
 
  const [keys, setKeys] = useState<any>([])
  const dbnpregistriesItems = useSelector(selectDbnpRegistriesListItems)
  const [openConfirmationFile, setOpenConfirmationFile] = React.useState(false);
  const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
  const [openConfirmationFavFile, setOpenConfirmationFavFile] = React.useState(false);
  const [logoFiles, setLogoFiles] = useState<any>([]);
  const [favFiles, setFavFiles] = useState<any>([]);
  const [openImageFile, setOpenImageFile] = useState<any>([]);
  const [brandMappings, setBrandMappings] = useState<any>([]);
  const [openFile, setOpenFile] = useState<any>([]);

  const addNewRow = ({ selectedKeysArg }: any) => {
    const localSelectedKeys = deepCopy(selectedKeysArg)
    const newsSelectedKeysRecord = {
      Id: 0,
      signing_pvt_key: '',
      signing_pub_key: '',
      encryption_pvt_key: '',
      encryption_pub_key: ''
    }
    if (localSelectedKeys.length === 0 ||
      localSelectedKeys[localSelectedKeys?.length - 1]?.signing_pvt_key !== ''
    ) {
      localSelectedKeys?.push(newsSelectedKeysRecord)
    }

    return localSelectedKeys
  }
  const setKeysInfo = async () => {
    let localSelectedKeys = deepCopy(keys)
    localSelectedKeys.splice(
      currentChange.idx,
      1,
      { ...localSelectedKeys[currentChange.idx] }
    );
    localSelectedKeys = addNewRow({ selectedKeysArg: localSelectedKeys });
    currentChange.field = 'signing_pvt_keyDONE'
    setKeys(localSelectedKeys)
  }

  const fetchOrgRegistryById = () => {
    dispatch(orgRegistries.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/query`,
      entity: 'orgRegistries',
      jsonData: {
        Records: [
          {
            Id: id,
            VendorId: '-1',
            UkId: '-1',
            AccountPId: '-1',
            AccountId: '-1'
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const fetchAcount = async (accoundTypeId: any) => {
     dispatch(accounts.list({
         url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
         entity: 'accounts',
         jsonData:
         {
           Context: {},
           Records: [
             {
               TypeId: accoundTypeId
             }
           ],
           Pagination: {
           }
         }
       }))
  }
  const fetchShippingProviders = async () => {
    dispatch(shippingProviders.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/shipment-management/shipping-providers/list`, entity: 'shippingProviders', jsonData: {
        Filters: [
          {
            FieldName: 'IsNetworkShippingProvider',
            FilterOperatorId: 1,
            FieldValue: true,
            FieldType: 'boolean'
          }
        ]
      }
    }))
  }

  useEffect(() => {
    fetchAcount({}).then(() => {
      fetchShippingProviders()
    }).then(() => {
      dispatch(shippingTypes.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {
        }
      }))
    }).then(() => {
      dispatch(dbnpRegistries.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/list`,
        entity: 'dbnpRegistries',
        jsonData: {
          "Filters": [
            {
            "FieldName": "IsProxyNetwork",
            "FilterOperatorId": 1,
            "FieldValue": false,
            "FieldType": "boolean"
            },
          ],
        }
    }))
}).then(() => {

  if (Number(id) > 0) {
        fetchOrgRegistryById()
        setIsLoading(false)
      } else {
        const currentSelectedKeys = addNewRow({ selectedKeysArg: keys });
        setKeys(currentSelectedKeys)
        const localSelectedBrands = addNewBrandMappingRow({ selectedBrandsArg: brandMappings });
        setBrandMappings(localSelectedBrands)
        const localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: logoFiles, brandMapping: brandMappings, idx1: 0 });
        setLogoFiles(localSelectedLogo)
        setIsLoading(false)
      }
    })
  }, []
  )
  useEffect(() => {
    if (isQuery) {
      setOrgRegistry(orgRegistryQuery?.result?.items)
      const newString = orgRegistryQuery?.result?.items?.Time?.days
      const daysArray: any = newString?.split(',').map(Number);
      setSelectedOrgRegistry(
        {
          gps: orgRegistryQuery?.result?.items?.Circle?.gps,
          unit: orgRegistryQuery?.result?.items?.Circle?.radius?.unit,
          value: orgRegistryQuery?.result?.items?.Circle?.radius?.value,
          days: daysArray,
          holidays: orgRegistryQuery?.result?.items?.Time?.schedule?.holidays,
          frequency: orgRegistryQuery?.result?.items?.Time?.schedule?.frequency,
          times: orgRegistryQuery?.result?.items?.Time?.schedule?.times,
          start: orgRegistryQuery?.result?.items?.Time?.range?.start,
          end: orgRegistryQuery?.result?.items?.Time?.range?.end,
        }
      )
      const currentSelectedKeys = addNewRow({ selectedKeysArg: orgRegistryQuery?.result?.items?.Keys || [] });
      setKeys(currentSelectedKeys)
      const brandData: any = orgRegistryQuery?.result?.items?.BrandMappings?.map((item: any) => {
        const itemData = {
          Id: item?.Id,
          Name: item?.Name,
          Description: item?.Description,
          PrimaryColor: item?.Configurations?.Branding?.Primary?.Color,
          PrimaryBackgroundColor: item?.Configurations?.Branding?.Primary?.BackgroundColor,
          PrimaryBackgroundImage: item?.Configurations?.Branding?.Primary?.BackgroundImage,
          SecondaryColor: item?.Configurations?.Branding?.Secondary?.Color,
          SecondaryBackgroundColor: item?.Configurations?.Branding?.Secondary?.BackgroundColor,
          SecondaryBackgroundImage: item?.Configurations?.Branding?.Secondary?.BackgroundImage,
          TertiaryColor: item?.Configurations?.Branding?.Tertiary?.Color,
          TertiaryBackgroundColor: item?.Configurations?.Branding?.Tertiary?.BackgroundColor,
          TertiaryBackgroundImage: item?.Configurations?.Branding?.Tertiary?.BackgroundImage,
          GhostColor: item?.Configurations?.Branding?.Ghost?.Color,
          GhostBackgroundColor: item?.Configurations?.Branding?.Ghost?.BackgroundColor,
          GhostBackgroundImage: item?.Configurations?.Branding?.Ghost?.BackgroundImage,
          Logos: item?.Configurations?.Logos?.map((logoItem: any) => {
            return {
              Url: logoItem.Url,
              Size: logoItem.Size,
              Background: logoItem.Background,
            };
          }),
          Favicons: item?.Configurations?.Favicons?.map((favItem: any) => {
            return {
              Url: favItem.Url,
              Size: favItem.Size,
              Background: favItem.Background,
            };
          }),
        }
        return itemData
      })
      const localSelectedbrands = addNewBrandMappingRow({ selectedBrandsArg: brandData || [] });
      setBrandMappings(localSelectedbrands)
      const updatedLogo = brandData?.map((brandMapping: any, index: any) => {
        const localSelectedlogo = addNewLogoFilesRow({
          selectedLogoFilesArg: brandMapping.Logos,
          brandMapping: localSelectedbrands,
          idx: brandMapping.Logos.length,
          idx1: index
        });
        return localSelectedlogo;
      });

      setLogoFiles(updatedLogo)
      const updatedFav = brandData?.map((brandMapping: any, index: any) => {
        const localSelectedlogo = addNewFavFilesRow({
          selectedFavFilesArg: brandMapping.Favicons,
          brandMapping: localSelectedbrands,
          idx: brandMapping.Favicons.length,
          idx1: index
        });
        return localSelectedlogo;
      });
      setFavFiles(updatedFav)
    }
  },
    [isQuery]
  )
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(keys);// deep copy of activity items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setKeys(items);
  }

  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field }
    setOrgRegistry({ ...orgRegistry, [field]: value })
    setSelectedOrgRegistry({ ...selectedOrgRegistry, [field]: value })
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedOrgRegistry({ ...selectedOrgRegistry, [fields[0]]: value });
    // setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }

  const handleFormItemBrandChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(brandMappings);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setBrandMappings(items);
  }

  const handleFormLogoItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Logos);
    items[idx] = { ...items[idx], [field]: value };
    setLogoFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Logos: items };
    setBrandMappings(updatedCardValue);
  }

  const handleFormFavItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Favicons);
    items[idx] = { ...items[idx], [field]: value };
    setFavFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Favicons: items };
    setBrandMappings(updatedCardValue);
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    keys.splice(
      keys.length - 1,
      1
    )
    brandMappings.splice(
      brandMappings.length - 1,
      1
    )
    const brandData: any = brandMappings.map((item: any) => {
      if (item?.Logos?.length) {
        item.Logos.splice(item.Logos.length - 1, 1);
      }
      if (item?.Favicons?.length) {
        item.Favicons.splice(item.Favicons.length - 1, 1);
      }
      const itemData = {
        Id: item?.Id,
        Name: item?.Name,
        Description: item?.Description,
        Configurations: {
          Logos: item?.Logos?.map((logoItem: any) => {
            return {
              Url: logoItem.Url,
              Size: logoItem.Size,
              Background: logoItem.Background,
            };
          }),
          Favicons: item?.Favicons?.map((favItem: any) => {
            return {
              Url: favItem.Url,
              Size: favItem.Size,
              Background: favItem.Background,
            };
          }),
          Branding: {
            Primary: {
              Color: item?.PrimaryColor,
              BackgroundColor: item?.PrimaryBackgroundColor,
              BackgroundImage: item?.PrimaryBackgroundImage
            },
            Secondary: {
              Color: item?.SecondaryColor,
              BackgroundColor: item?.SecondaryBackgroundColor,
              BackgroundImage: item?.SecondaryBackgroundImage
            },
            Tertiary: {
              Color: item?.TertiaryColor,
              BackgroundColor: item?.TertiaryBackgroundColor,
              BackgroundImage: item?.TertiaryBackgroundImage
            },
            Ghost: {
              Color: item?.GhostColor,
              BackgroundColor: item?.GhostBackgroundColor,
              BackgroundImage: item?.GhostBackgroundImage
            },
          },
        }
      }
      return itemData
    })
    const newString: any = selectedOrgRegistry?.days.map((x: any) => x).join(',')
    const orgRegistryData = {
      Id: orgRegistry?.Id || 0,
      IsAcceptOrderByDefaultEnabled: orgRegistry?.IsAcceptOrderByDefaultEnabled || true,
      IsDirectShipmentEnabled: orgRegistry?.IsDirectShipmentEnabled || true,
      Keys: keys || [],
      UkId: orgRegistry?.UkId || '',
      BrandMappings: brandData,
      Delivery_preference: orgRegistry?.Delivery_preference || '',
      Shipping_category: orgRegistry?.Shipping_category || '',
      Circle: {
        gps: selectedOrgRegistry?.gps || '',
        radius: {
          unit: selectedOrgRegistry?.unit || '',
          value: selectedOrgRegistry?.value || ''
        }
      },
      Time: {
        days: newString || '',
        schedule: {
          holidays: selectedOrgRegistry?.holidays || [],
          frequency: selectedOrgRegistry?.frequency || '',
          times: selectedOrgRegistry?.times || []
        },
        range: {
          start: selectedOrgRegistry?.start || '',
          end: selectedOrgRegistry?.end || ''
        }
      },
      CurrentlyServicing: orgRegistry?.CurrentlyServicing || false,
      UseSettingsFromConfigFile: orgRegistry?.UseSettingsFromConfigFile || false,
      Stdcode: 'string',
      VendorId: orgRegistry?.VendorId || 0,
      AccountPId: orgRegistry?.AccountPId || 0,
      AccountId: orgRegistry?.AccountId || 0,
      AccountTypeId: orgRegistry?.AccountTypeId || 0,
      PreferredLogisticProviderAccountIds: orgRegistry?.PreferredLogisticProviderAccountIds || [],
      ShippingTypeId: orgRegistry?.ShippingTypeId || 0,
      ShippingOptionIds: orgRegistry?.ShippingOptionIds || [],
      DBNPRegistryId :orgRegistry?.DBNPRegistryId || 0, 
      IsTrackingEnabled: orgRegistry?.IsTrackingEnabled || false, 
      Tracking: {
        code: orgRegistry?.code || '',
        list: [
          {
            code: orgRegistry?.code || '',
            value: orgRegistry?.value || '',
          }
        ]
      },
      PreferredTransporterAccountIds: orgRegistry?.PreferredTransporterAccountIds || [],
    }
    if (Number(id) > 0) {
      await dispatch(orgRegistries.resetAction({ actionType: 'update' }))
      await dispatch(orgRegistries.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries`,
        entity: 'orgRegistries',
        jsonData: {
          Context: {},
          Records: [
            orgRegistryData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(orgRegistries.resetAction({ actionType: 'create' }))
      await dispatch(orgRegistries.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries`,
        entity: 'orgRegistries',
        jsonData: {
          Context: {},
          Records: [
            orgRegistryData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate(`/management/organization/dbn/dbnp-registries/${dbnpRegistryId}?tab=Org+Registries`)
  }

  const deleteKeys = async (Item: any, index: any) => {
    const card = deepCopy(keys)
    card?.splice(
      index,
      1
    )
  }
  useEffect(
    () => {
      if (currentChange.field === 'signing_pvt_key') {
        setKeysInfo()
      }
    },
    [keys]
  )

  const handleClose = () => {
    if (openConfirmationLogoFile) {
      setOpenConfirmationLogoFile(false)
    } else if (openConfirmationFavFile) {
      setOpenConfirmationFavFile(false)
    }
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  const addNewBrandMappingRow = ({ selectedBrandsArg }: any) => {
    const localSelectedBrands = deepCopy(selectedBrandsArg)
    const newsBrand = {
      Id: 0,
      Name: '',
      Description: '',
      Logos: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Favicons: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Branding: {
        Primary: {},
        Secondary: {},
        Tertiary: {},
        Ghost: {}
      }
    }
    if (localSelectedBrands.length === 0 ||
      localSelectedBrands[localSelectedBrands?.length - 1]?.Name !== ''
    ) {
      localSelectedBrands?.push(newsBrand);
    }
    return localSelectedBrands
  }

  const addNewLogoFilesRow = ({ selectedLogoFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedlogo = deepCopy(selectedLogoFilesArg)
    const newSelectedLogo = {
      Url: '',
      Size: '',
      Background: '',
    }
    if (localSelectedlogo.length === 0 ||
      brandMapping[idx1]?.Logos[brandMapping[idx1].Logos?.length - 1]?.Url !== ''
    ) {
      brandMapping[idx1]?.Logos?.push(newSelectedLogo)
    }
    return localSelectedlogo
  }

  const addNewFavFilesRow = ({ selectedFavFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedfav = deepCopy(selectedFavFilesArg)
    const newSelectedFav = {
      Url: '',
      Size: '',
      Background: '',
    }
    if (localSelectedfav.length === 0 ||
      brandMapping[idx1]?.Favicons[brandMapping[idx1].Favicons?.length - 1]?.Url !== ''
    ) {
      brandMapping[idx1]?.Favicons?.push(newSelectedFav)
    }
    return localSelectedfav
  }

  const setCombinationLogoInfo = async () => {
    let localSelectedLogo = deepCopy(logoFiles)
    localSelectedLogo.splice(
      currentChange.idx,
      1,
      { ...localSelectedLogo[currentChange.idx] }
    );
    localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: localSelectedLogo, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setLogoFiles(localSelectedLogo)
  }

  const setCombinationFavInfo = async () => {
    let localSelectedFav = deepCopy(favFiles)
    localSelectedFav.splice(
      currentChange.idx,
      1,
      { ...localSelectedFav[currentChange.idx] }
    );
    localSelectedFav = addNewFavFilesRow({ selectedFavFilesArg: localSelectedFav, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setFavFiles(localSelectedFav)
  }

  const setCombinationBrandInfo = async () => {
    let localSelectedbrands = deepCopy(brandMappings)
    localSelectedbrands.splice(
      currentChange.idx,
      1,
      { ...localSelectedbrands[currentChange.idx] }
    );
    localSelectedbrands = addNewBrandMappingRow({ selectedBrandsArg: localSelectedbrands });
    currentChange.field = 'NameDONE'
    setBrandMappings(localSelectedbrands)
  }

  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationLogoInfo()
      }
    },
    [currentChange.field, currentChange.idx]
  )

  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationFavInfo()
      }
    },
    [currentChange.field, currentChange.idx]
  )

  useEffect(
    () => {
      if (currentChange.field === 'Name') {
        setCombinationBrandInfo()
      }
    },
    [brandMappings]
  )

  const handleLogoSubmit = (data: any) => {
    const newLogoFiles = [...logoFiles];
    const logosArray = brandMappings[currentChange.idx1]?.Logos;
    logosArray[currentChange.idx].Url = data;
    const localSelectedLogo = addNewLogoFilesRow({
      selectedLogoFilesArg: newLogoFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });
    setLogoFiles(localSelectedLogo)
  }

  const changeImage = (idx: number, templateField: any, fileType: any, brandMaping: any) => {
    // setOrganizationUnitImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationFile(true)
    setOpenFile({
      currentFileSrc: brandMaping[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
  }

  const changeLogoImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationLogoFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Logos[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    currentChange = { idx, templateField, idx1 }
  }

  const changeFavImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationFavFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Favicons[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    currentChange = { idx, templateField, idx1 }
  }

  const handleFavSubmit = (data: any) => {
    const newfavFiles = [...favFiles];
    const favsArray = brandMappings[currentChange.idx1]?.Favicons;
    favsArray[currentChange.idx].Url = data;
    const localSelectedFav = addNewFavFilesRow({
      selectedFavFilesArg: newfavFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });
    setFavFiles(localSelectedFav)
  }

  return (
    <>
      {getUploadFiles == 'open' && openConfirmationLogoFile && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleLogoSubmit}
        type={openImageFile?.type}
        ownerId={id}
      />}
      {getUploadFiles == 'open' && openConfirmationFavFile && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleFavSubmit}
        type={openImageFile?.type}
        ownerId={id}
      />}
      {isLoading ? <PageLoader /> :
        <OrgRegistryComponent
          deleteKeys={deleteKeys}
          accountType={libraryListItems.Type}
          deliveryPreference={libraryListItems.DeliveryPreference}
          onFormItemChange={handleFormItemChange}
          keys={keys}
          onFormChange={handleFormChange}
          orgRegistry={orgRegistry}
          fetchAcount={fetchAcount}
          accounts={accountsItems?.result?.items}
          shippingProviders={shippingProvidersListItems?.result?.items}
          id={id}
          selectedOrgRegistry={selectedOrgRegistry}
          shippingTypes={shippingTypesListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}

          onFormFavItemChange={handleFormFavItemChange}
          changeFavImage={changeFavImage}
          logoFiles={logoFiles}
          onFormLogoItemChange={handleFormLogoItemChange}
          faviconSize={libraryListItems.FaviconSize}
          changeLogoImage={changeLogoImage}
          logoBackground={libraryListItems.LogoBackground}
          onFormItemBrandChange={handleFormItemBrandChange}
          brandMappings={brandMappings}
          fileTypes={libraryListItems.FileType}
          changeImage={changeImage}
          handleInnerbasicFormChange={handleFormChange}
          // selectedAddress={selectedAddress}
          // timeZones={timeZonesItems?.result?.items}
          currencyRoundingType={libraryListItems.RoundingType}
          currencyCodeType={libraryListItems.CurrencyCodeType}
          // selectedOrganizationUnit={selectedOrgRegistry}
          onInnerFormChange={handleInnerFormChange}
          dbnpregistries={dbnpregistriesItems?.result?.items}
        />
      }
    </>
  )

}

export default DBNPOrgRegistry;